// Shared demo products used across pages when backend is unavailable
const DEMO_PRODUCTS = [
  {
    _id: 'demo-1',
    name: 'Southern Oak',
    category: 'Wood Look',
    description: 'Natural oak wood appearance with straight, large and long grain. Colors from light white to dark brown enhances elegance and natural feel.',
    pricing_mode: 'RFQ_ONLY',
    image_urls: [],
    specs: { thickness: 6, wear_layer: '0.5mm', waterproof: true, surface_texture: 'Wood', locking_system: 'Unilin Click Lock' },
  },
  {
    _id: 'demo-2',
    name: 'Maple Forest',
    category: 'Wood Look',
    description: 'Exceptional flooring with thoughtful designs. Waterproof and chemical-free—great for kitchens and laundry rooms.',
    pricing_mode: 'RFQ_ONLY',
    image_urls: [],
    specs: { thickness: 5, wear_layer: '0.3mm', waterproof: true, surface_texture: 'Wood', locking_system: 'Unilin Click Lock' },
  },
  {
    _id: 'demo-3',
    name: 'Walnut Grove',
    category: 'Wood Look',
    description: 'Deep colors of natural walnut creating warm and luxurious feel. Unique grain pattern with pre-attached underlay.',
    pricing_mode: 'RFQ_ONLY',
    image_urls: [],
    specs: { thickness: 8, wear_layer: '0.5mm', waterproof: true, surface_texture: 'Wood', locking_system: 'Unilin Click Lock' },
  },
  {
    _id: 'demo-4',
    name: 'Earth Stone',
    category: 'Stone Look',
    description: 'Designed for everyday demands—improved scratch and stain resistance with 100% waterproof multilayer construction.',
    pricing_mode: 'RFQ_ONLY',
    image_urls: [],
    specs: { thickness: 6, wear_layer: '0.3mm', waterproof: true, surface_texture: 'Marble', locking_system: 'Unilin Click Lock' },
  },
  {
    _id: 'demo-5',
    name: 'EIR Collection',
    category: 'Embossed-in-Register',
    description: 'Authentic real-wood experience with Embossed-in-Register technology, perfectly replicating natural grain, depth, and texture.',
    pricing_mode: 'RFQ_ONLY',
    image_urls: [],
    specs: { thickness: 8, wear_layer: '0.7mm', waterproof: true, surface_texture: 'EIR', locking_system: 'Unilin Click Lock' },
  },
];

export default DEMO_PRODUCTS;
